<script>
import _ from 'lodash'
import u from '@/utils'
import { mapGetters } from 'vuex'

export default {
  props: {
    title: {
      type: String,
      default: 'Title'
    },

    multiple: {
      type: Boolean,
      default: true
    },

    searchAttributes: {
      type: Array,
      default() {
        return []
      }
    },

    selectedItems: {
      type: Array,
      default() {
        return []
      }
    },

    allItems: {
      type: Array,
      default() {
        return []
      }
    },

    editMode: {
      type: Boolean,
      default: false
    },

    addMode: {
      type: Boolean,
      default: false
    },

    updating: {
      type: Boolean,
      default: false
    },
    itemsList: []
  },
  methods: {
    isSelected(item, inItems) {
      return inItems.filter(i => i.hexId === item.hexId).length
    },

    toggleItemSelect(item, inItems) {
      if (this.isSelected(item, inItems)) {
        this.unselectItem(item, inItems)
      } else {
        this.selectItem(item, inItems)
      }
    },

    selectItem(item, inItems) {
      if (this.multiple) {
        if (!this.isSelected(item, inItems)) {
          inItems.push(item)
        }
      } else {
        if (!this.isSelected(item, inItems)) {
          inItems.splice(0, 1)
          inItems.push(item)
        }
      }
    },

    unselectItem(item, inItems) {
      inItems.splice(inItems.findIndex(i => i.hexId === item.hexId), 1)
    },

    containsQuery(item) {
      if (!this.query.trim()) {
        return true
      } else {
        let containsQuery = false
        for (let attr of this.searchAttributes) {
          let query = this.query.trim().toLowerCase()
          containsQuery =
            _.get(item, attr) &&
            _.get(item, attr).length &&
            _.get(item, attr)
              .toLowerCase()
              .indexOf(query) > -1
          if (containsQuery) {
            break
          }
        }
        return containsQuery
      }
    },

    switchMode(mode) {
      switch (mode) {
        case 'view':
          this.editActive = false
          this.addActive = false
          this.deleteActive = false
          break
        case 'edit':
          this.editActive = true
          this.addActive = false
          this.deleteActive = false
          break
        case 'add':
          this.addItems = _.differenceWith(
            this.allItems,
            this.selectedItems,
            (all, selected) => {
              return all.hexId === selected.hexId
            }
          )
          // this.addItemsChecked = []
          this.editActive = true
          this.addActive = true
          this.deleteActive = false
          break
        case 'delete':
          this.deleteItems = u.clone(this.selectedItems)
          this.deleteItemsChecked = []
          this.editActive = true
          this.addActive = false
          this.deleteActive = true
          break
        default:
          console.error(`Mode ${mode} does not exist`)
      }
    },

    confirmAdd() {
      this.$emit('added', this.addItemsChecked)
      this.switchMode('view')
    },

    confirmDelete() {
      this.$emit('deleted', this.deleteItemsChecked)
      this.switchMode('view')
    },

    checkItemIsSelected(item) {
      return this.selectedItems.find(i => i.hexId === item.hexId)
    },

    search(query) {
      if (query === '') this.deleteItems = [...this.selectedItems]
      this.deleteItems = this.selectedItems.filter(el => {
        for (let attr of this.searchAttributes) {
          const fieldValue = el[attr]
          if (fieldValue) {
            if (fieldValue.toLowerCase().includes(query)) return el
          }
        }
      })
    }
  },

  watch: {
    selectedItems() {
      this.addItemsChecked = [...this.selectedItems]
      this.query = ''
    },
    allItems() {
      this.itemsList = this.allItems.map(item => {
        item.isSelected = this.checkItemIsSelected(item) ? true : false
        return item
      })
    }
  },

  data() {
    return {
      editActive: this.editMode,
      addActive: this.addMode,
      deleteActive: false,
      query: '',
      addItems: [],
      addItemsChecked: [...this.selectedItems],
      deleteItems: [],
      deleteItemsChecked: []
    }
  },

  computed: {
    ...mapGetters({
      can: 'can'
    })
  }
}
</script>

<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense card class="elevation-2">
          <v-toolbar-title class="body-2 beez-bold "
            >{{ title }}
          </v-toolbar-title>
          <v-layout justify-end>
            <transition name="fade" mode="out-in">
              <v-tooltip v-if="editActive" key="view" bottom>
                <v-btn flat icon @click="switchMode('view')" slot="activator">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <span>View Mode</span>
              </v-tooltip>
              <v-tooltip v-else key="edit" bottom>
                <v-btn
                  flat
                  icon
                  @click="switchMode('edit')"
                  slot="activator"
                  v-if="
                    can(
                      'IDENTITIES_BOTS_EDIT' ||
                        'BOT_IDENTITIES_EDIT' ||
                        'USER_ROLE_EDIT' ||
                        'PROFILE_BOT_UPDATE' ||
                        'PROFILE_WORKFLOW_UPDATE' ||
                        'PROFILE_SERVICE_UPDATE' ||
                        'PROFILE_USER_UPDATE' ||
                        'BOT_IDENTITIES'
                    )
                  "
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Edit Mode</span>
              </v-tooltip>
            </transition>
            <v-btn
              v-if="addActive"
              flat
              icon
              @click="addActive = false"
              slot="activator"
            >
              <v-icon>navigate_before</v-icon>
            </v-btn>
            <v-btn
              v-if="addActive"
              flat
              icon
              @click="confirmAdd()"
              slot="activator"
            >
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
            <v-btn
              v-if="deleteActive"
              flat
              icon
              @click="deleteActive = false"
              slot="activator"
            >
              <v-icon>navigate_before</v-icon>
            </v-btn>
            <v-btn
              v-if="deleteActive"
              flat
              icon
              @click="confirmDelete()"
              slot="activator"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </v-layout>
        </v-toolbar>
        <v-progress-linear
          indeterminate
          color="accent"
          class="ma-0"
          height="5"
          :active="updating"
        />
        <transition name="bounce" mode="out-in">
          <v-list
            two-line
            v-if="!editActive"
            key="view-list"
            style="max-height: 760px"
            class="scroll-y"
          >
            <v-list-tile avatar v-if="!selectedItems.length">
              <v-list-tile-avatar>
                <v-btn icon ripple class="ma-1">
                  <v-icon>error_outline</v-icon>
                </v-btn>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  <slot name="empty-list-placeholder-selected">List empty</slot>
                </v-list-tile-title>
                <v-list-tile-sub-title />
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  icon
                  ripple
                  @click="switchMode('add')"
                  v-if="
                    can(
                      'IDENTITIES_BOTS_EDIT' ||
                        'BOT_IDENTITIES_EDIT' ||
                        'USER_ROLE_EDIT' ||
                        'PROFILE_BOT_UPDATE' ||
                        'PROFILE_WORKFLOW_UPDATE' ||
                        'PROFILE_SERVICE_UPDATE' ||
                        'PROFILE_USER_UPDATE' ||
                        'BOT_IDENTITIES'
                    )
                  "
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile avatar v-for="(item, i) in selectedItems" :key="i">
              <slot name="list-item-selected" :item="item"></slot>
            </v-list-tile>
          </v-list>

          <v-list
            two-line
            v-else-if="editActive && !addActive && !deleteActive"
            key="edit-list"
            style="max-height: 760px"
            class="scroll-y"
          >
            <v-layout row wrap>
              <v-flex xs6>
                <v-list-tile @click="switchMode('add')">
                  <v-list-tile-avatar>
                    <v-icon>add</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>Add More</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-flex>
              <v-flex xs6>
                <v-list-tile @click="switchMode('delete')">
                  <v-list-tile-content>
                    <v-list-tile-title class="text-xs-right"
                      >Delete
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon>delete</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-flex>
            </v-layout>
          </v-list>

          <v-list
            two-line
            v-else-if="addActive"
            key="add-list"
            style="max-height: 760px"
            class="scroll-y"
          >
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon ripple>search</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <v-text-field
                    color="secondary"
                    v-model="query"
                    label="Search"
                    xs5
                    @keyup.enter="$emit('queryChanged', query)"
                  >
                  </v-text-field>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-tooltip bottom>
                <v-btn slot="activator" flat icon @click="query = ''">
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>Clear search</span>
              </v-tooltip>
            </v-list-tile>
            <v-list-tile
              avatar
              v-for="(item, i) in itemsList"
              :key="i"
              @click="toggleItemSelect(item, addItemsChecked)"
              :disabled="item.isSelected"
            >
              <slot name="list-item-add" :item="item" />
              <v-list-tile-action>
                <v-flex v-if="multiple">
                  <v-btn icon ripple>
                    <v-icon v-if="isSelected(item, addItemsChecked)"
                      >check_box
                    </v-icon>
                    <v-icon v-else>check_box_outline_blank</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-else>
                  <v-btn icon ripple>
                    <v-icon v-if="isSelected(item, addItemsChecked)"
                      >radio_button_checked
                    </v-icon>
                    <v-icon v-else>radio_button_unchecked</v-icon>
                  </v-btn>
                </v-flex>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-list
            two-line
            v-else-if="deleteActive"
            key="delete-list"
            style="max-height: 760px"
            class="scroll-y"
          >
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon>search</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-sub-title>
                  <v-text-field
                    color="secondary"
                    v-model="query"
                    label="Search"
                    xs5
                    @keyup.enter="search(query)"
                  >
                  </v-text-field>
                </v-list-tile-sub-title>
              </v-list-tile-content>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  flat
                  icon
                  @click="
                    query = ''
                    search(query)
                  "
                >
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>Clear search</span>
              </v-tooltip>
            </v-list-tile>
            <v-list-tile
              avatar
              v-for="(item, i) in deleteItems"
              :key="i"
              @click="toggleItemSelect(item, deleteItemsChecked)"
            >
              <slot name="list-item-delete" :item="item" />
              <v-list-tile-action>
                <v-flex v-if="multiple">
                  <v-btn icon ripple>
                    <v-icon v-if="isSelected(item, deleteItemsChecked)"
                      >check_box
                    </v-icon>
                    <v-icon v-else>check_box_outline_blank</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-else>
                  <v-btn icon ripple>
                    <v-icon v-if="isSelected(item, deleteItemsChecked)"
                      >radio_button_checked
                    </v-icon>
                    <v-icon v-else>radio_button_unchecked</v-icon>
                  </v-btn>
                </v-flex>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </transition>
      </v-card>
    </v-flex>
  </v-layout>
</template>
